import { createSlice } from '@reduxjs/toolkit'

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    usersTableFilters: { page: 0, pageSize: 50, query: '' }
  },
  reducers: {
    setUsersTableFilters(state, action) {
      state.usersTableFilters = action.payload
    },
    resetUsersTableFilters(state) {
      state.usersTableFilters = { page: 0, pageSize: 50, query: '' }
    }
  }
})

export const { setUsersTableFilters, resetUsersTableFilters } =
  usersSlice.actions

export default usersSlice.reducer
